export const ATHLETES_VISIBILITY_TYPES = Object.freeze({
  everyone: 'everyone',
  followers: 'followers_only',
  onlyMe: 'only_me',
  noOne: 'no_one',
  optedIn: 'opted_in',
  optedOut: 'opted_out'
});

export default { ATHLETES_VISIBILITY_TYPES };
